import React from "react";
import "./pages/css/Footer.css"

const Footer = () => {
  return (
      <footer>
    <div class="grid-container">
            <div class="grid-item"> <img class="footlogo" src="/logowhite.png"/>
                <div class="foottext">Bhanimandal near to 12 Basket ,Lalitpur, Nepal <br/>
                    Opposite to Alka hospital, Lalitpur 44600</div>
                <div class="foottext">© 2021-2022 Mission Oxygen Team Nepal.</div></div>
            <div class="grid-item">
                <h4 class="head">About Us</h4>
                <ul>
                    <li><a class="FooterText"href="/about/members">Leads</a></li>
                    <li><a class="FooterText" href="/about/organization">Organizations</a></li>
                    <li><a class="FooterText" href="/about/mainpage">Objective</a></li>
                    <li><a class="FooterText" href="/about/contact">Contact</a></li>
                </ul>
            </div>
            <div class="grid-item">
                <h4 class="head2">Links</h4>
                <ul>
                    <li><a class="FooterText" href="/request">Request Support</a></li>
                    <li><a class="FooterText" href="/apply">Member Request</a></li>
                    <li><a class="FooterText" href="/donation">Donation</a></li>
                </ul>
            </div>  
            <div class="grid-item">
                <a href="https://www.facebook.com/missionoxygenteam/"><img class="footlogo2" src="/facebook.png"/></a>
                <a href="https://www.instagram.com/missionoxygenteam/"><img class="footlogo2" src="/instagram.png"/></a>
                <a href="https://www.linkedin.com/company/mission-oxygen-team-mot/mycompany/"><img class="footlogo2" src="/linkedin.png"/></a>
                <a href="https://mobile.twitter.com/mot_oxygenteam"><img class="footlogo2" src="/twitter.png"/></a>
            </div> 
          </div>
        
    </footer>
  );
};

export default Footer;
